module.exports = __webpack_public_path__ + "school/img/fuzhu.a5f19e35.jpg";